import Swal from "sweetalert2";
import { queryClient } from "../queryClient";

const DeleteHook = ({ refetch, setRefetch, url }) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      fetch(`${url}`, {
        method: "DELETE",
      }).then((res) => {
        if (res.status === 200) {
          if (typeof setRefetch === "function") {
            setRefetch(!refetch);
          }
          queryClient.invalidateQueries();
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
        }
      });
    }
  });
};

export default DeleteHook;
